import React, { Component } from "react";

import Link from "components/link/link";
import Button from "components/button/button";

import "./comingSoon.css";

export default class ComingSoon extends Component {
  render() {
    return (
      <div className="comingSoon">
        <Link to={`/about/contact`}>
          <div className="buttonContainer">
            <Button color="green">
              <p>Coming Soon</p>
              <p>Subscribe For Updates</p>
            </Button>
          </div>
        </Link>
      </div>
    );
  }
}
